/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { createRef } from "react";
import { Table, Tag, Divider, Icon, Button, Input, Popconfirm, message } from "antd";
import { Session } from "../../../business";
import { sendHttpRequest } from "../../../components/http.request";

export const ProcessTable = ({ tableDatasource, loading, goTo, handleTableChange, filter, setToggleUpdateList }) => {
    const handleSearch = (_, confirm) => {
        confirm();
    };

    const handleReset = (clearFilters) => {
        clearFilters();
    };

    const getColumnSearchProps = (dataIndex) => {
        const searchInput = createRef();

        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={searchInput}
                        placeholder={`Pesquisar`}
                        value={selectedKeys}
                        onChange={(e) => setSelectedKeys(e.target.value ? e.target.value : null)}
                        onPressEnter={() => handleSearch(selectedKeys, confirm)}
                        style={{ width: 198, marginBottom: 8, display: "block" }}
                    />
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm)}
                        icon="search"
                        size="small"
                        style={{ width: 100, marginRight: 8 }}
                    >
                        Pesquisar
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" icon="cl" style={{ width: 90 }}>
                        Limpar
                    </Button>
                </div>
            ),
            filterIcon: (filtered) => <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />,
            filteredValue: filter[`filtro_${dataIndex}`] || null,
            onFilterDropdownVisibleChange: (visibleDropdown) => {
                if (visibleDropdown) {
                    setTimeout(() => searchInput?.current?.focus(), 100);
                }
            },
        };
    };
    const getColumnSortProps = (dataIndex) => {
        return {
            sorter: true,
            sortOrder: filter?.sorter?.columnKey === dataIndex && filter?.sorter?.order,
        };
    };

    function handleToggleStateProcess(code, status) {
        const formData = new FormData();
        formData.append("accao", "ativa_inativa");
        formData.append("codigo", code);
        formData.append("estado", status ? "ativar" : "inativar");

        sendHttpRequest("POST", "/Gestor/gereprocesso.php", formData).then((jsonResponse) => {
            if (jsonResponse.sucesso) {
                message.success(`${status ? "Ativado" : "Inativado"} com sucesso`);
                setToggleUpdateList();
            } else {
                message.error("Ocorreu um erro");
            }
        });
    }

    const isQa = Session.getUsername() === "qa";

    const columns = [
        {
            title: "Código",
            dataIndex: "codigo_externo",
            key: "codigo_externo",
            width: "10%",
            ...getColumnSearchProps("codigo_externo"),
            ...getColumnSortProps("codigo_externo"),
            render: (codigo, record) => {
                return <Tag color={record.forma_iniciar === "_obsoleto_" ? "red" : "green"}>{codigo}</Tag>;
            },
        },
        {
            title: "Nome",
            dataIndex: "nome_externo",
            key: "nome_externo",
            width: "15%",
            sortDirections: ["descend", "ascend"],
            ...getColumnSearchProps("nome_externo"),
            ...getColumnSortProps("nome_externo"),
        },
        {
            title: "Âmbito",
            width: "25%",
            dataIndex: "ambito",
            key: "ambito",
            ...getColumnSearchProps("ambito"),
        },
        {
            title: "Versão",
            dataIndex: "versao",
            key: "versao",
            width: "10%",
            ...getColumnSearchProps("versao"),
            ...getColumnSortProps("versao"),
        },
        {
            title: "Estado",
            dataIndex: "estado_processo",
            key: "estado_processo",
            width: "10%",
            filters: [
                {
                    text: "Aprovado",
                    value: "Aprovado",
                },
                {
                    text: "Em elaboração",
                    value: "Em elaboração",
                },
                {
                    text: "Obsoleto",
                    value: "Obsoleto",
                },
            ],
            filterMultiple: false,
            render: (text) => {
                const color = text === "Aprovado" ? "green" : text === "Obsoleto" ? "red" : "rgba(0, 0, 0, 0.65)";
                return (
                    <span
                        style={{
                            color: color,
                            width: 120,
                            textAlign: "center",
                        }}
                    >
                        {text}
                    </span>
                );
            },
        },
        {
            title: "Utilizável",
            dataIndex: "utilizado",
            key: "utilizado",
            width: "10%",
            filters: [
                {
                    text: "Sim",
                    value: "Sim",
                },
                {
                    text: "Não",
                    value: "Não",
                },
            ],
            filterMultiple: false,
            render: (text) => {
                const color = text === "Sim" ? "green" : "red";
                return (
                    <span
                        style={{
                            color: color,
                            width: 120,
                            textAlign: "center",
                        }}
                    >
                        {text}
                    </span>
                );
            },
        },
        {
            title: "Ações",
            dataIndex: "",
            width: "10%",
            key: "action",
            render: (_, record) => (
                <span>
                    <Button type="link" style={{ padding: 0 }} onClick={() => goTo(record.id)}>
                        Detalhes
                    </Button>

                    {record.forma_iniciar === "pop_social_mask" && (
                        <>
                            <Divider type="vertical" />
                            <Button type="link" style={{ padding: 0 }} onClick={() => goTo(record.id, true)}>
                                Subprocessos
                            </Button>
                        </>
                    )}

                    {isQa && record.forma_iniciar === "_obsoleto_" && (
                        <>
                            <Divider type="vertical" />
                            <Popconfirm
                                title="Tem certeza que pretende ativar?"
                                onConfirm={() => handleToggleStateProcess(record.codigo, true)}
                                okText="Sim"
                                cancelText="Não"
                            >
                                <Button type="link" style={{ padding: 0 }}>
                                    Ativar
                                </Button>
                            </Popconfirm>
                        </>
                    )}

                    {isQa && record.forma_iniciar !== "_obsoleto_" && (
                        <>
                            <Divider type="vertical" />

                            <Popconfirm
                                title="Tem certeza que pretende inativar?"
                                onConfirm={() => handleToggleStateProcess(record.codigo, false)}
                                okText="Sim"
                                cancelText="Não"
                            >
                                <Button type="link" style={{ padding: 0, color: "red" }}>
                                    Inativar
                                </Button>
                            </Popconfirm>
                        </>
                    )}
                </span>
            ),
        },
    ];

    return (
        <Table
            size="middle"
            loading={loading}
            rowKey={(data) => data.id + "-table"}
            onRow={(record) => {
                return {
                    onDoubleClick: () => {
                        goTo(record.id);
                    },
                    onMouseEnter: (event) => {
                        event.target.style.cursor = "pointer";
                    },
                    onMouseLeave: (event) => {
                        event.target.style.cursor = "none";
                    },
                };
            }}
            pagination={false}
            columns={columns}
            dataSource={tableDatasource}
            onChange={handleTableChange}
        />
    );
};
